import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/images/footerlogimg.png';
import google from '../../assets/images/google.svg';
import facebook from '../../assets/images/facebook.svg';
import instagram from '../../assets/images/instagram.svg';
import linkedin from '../../assets/images/linkedin.svg';  
function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-col footer-brand">
          <Link to="/" className="footer-logo">
            <img className="footer-logo-img" src={logo} alt="The David Foster Preschool & Afterschool Academy" />
          </Link>
          <div className="footer-brand-title">
            The David Foster Preschool &<br /> Afterschool Academy
          </div>
          <p className="footer-brand-desc">
            Nurturing young minds through play, discovery, and structured early education since 1992
          </p>

          <div className="footer-social" aria-label="Social links">
            <a href="#facebook" aria-label="Facebook" className="footer-social-link">
             <img src={facebook} alt="Facebook" />
            </a>
            <a href="#instagram" aria-label="Instagram" className="footer-social-link">
            <img src={instagram} alt="Instagram" /> 
            </a>
            <a href="#linkedin" aria-label="LinkedIn" className="footer-social-link">
            <img src={linkedin} alt="LinkedIn" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <nav className="footer-col footer-links" aria-label="Quick Links">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-link-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About us</Link></li>
            <li><Link to="/programs">Programs</Link></li>
            <li><Link to="/admissions">Admissions</Link></li>
            <li><Link to="/resources">Parent Resources</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/news-calendar">News & Calendar</Link></li>
            <li><Link to="/health-safety">Health & Safety</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        {/* Contact */}
        <div className="footer-col footer-contact" id="contact">
          <h4 className="footer-heading">Contact Us</h4>
          <ul className="footer-contact-list">
            <li className="footer-contact-item">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                </svg>
              </span>
              <span>72 Clarkson Avenue, Brooklyn, New York 11226</span>
            </li>

            <li className="footer-contact-item">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.5 3.5L9.2 7.2c.2.5.1 1.1-.3 1.5L7.6 10c1.4 2.7 3.7 5 6.4 6.4l1.3-1.3c.4-.4 1-.5 1.5-.3l3.7 1.7c.6.3.8.9.6 1.5-.5 1.5-1.9 2.5-3.5 2.5-7.5 0-14.1-6.6-14.1-14.1 0-1.6 1-3 2.5-3.5.6-.2 1.2 0 1.5.6Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <a href="tel:718-462-0776">718-462-0776</a>
            </li>

            <li className="footer-contact-item">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 7.5A2.5 2.5 0 0 1 6.5 5h11A2.5 2.5 0 0 1 20 7.5v9A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-9Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                  <path
                    d="M5.5 7.5 12 12.2l6.5-4.7"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <a href="mailto:davidfosterpreschool@verizon.net">davidfosterpreschool@verizon.net</a>
            </li>

            <li className="footer-contact-item">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 8v4l2.5 1.5"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 12c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                </svg>
              </span>
              <span>
                Monday - Friday: 8:00 AM - 7:00 PM
                <br />
                Sat - Sun: Closed
              </span>
            </li>
          </ul>
        </div>

        {/* Google rating */}
        <div className="footer-col footer-rating" aria-label="Google rating">
          <div className="footer-google-card">
            <div className="footer-google-mark" aria-hidden="true">
              <img src={google} alt="" />
            </div>
            <div className="footer-google-content">
              <div className="footer-google-label">Google Rating</div>
              <div className="footer-google-row">
                <div className="footer-google-score">4.8</div>
                <div className="footer-google-stars" aria-hidden="true">★★★★★</div>
              </div>
              <div className="footer-google-sub">Rating 4.8 (63 Reviews)</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
